import DentalReportImages from "./DentalReportImages";
export default DentalReportImages;
export { DentalReportImagesSummary } from "./DentalReportImagesSummary";
export type { ImageFile } from "./DentalReportImages";
export { ImageTypes } from "./DentalReportImages";